import { ADDBOOK, DELETE, LOADED, UPDATE } from "./actions";
import initialState from "./initialState";

const IdGenerator = (books) =>{
    const newId = books.reduce((newId, book) => Math.max(book.id, newId), -1);
    return newId + 1;
}

const BookReducer = (state = initialState, actions) => {
  switch (actions.type) {
    case LOADED:
      return actions.payload;

    case ADDBOOK:
      return [
        ...state,
        {
          id: IdGenerator(state),
          ...actions.payload,
        },
      ];

    case UPDATE:
      return state.map((book) => {
        if (book.id === actions.payload.id) {
          return actions.payload.value;
        } else {
          return book;
        }
      });

    case DELETE:
      return state.filter((book) => book.id !== actions.payload);

    default:
      return state;
  }
};

export default BookReducer;
